"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerTemplates = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const scheduler_1 = require("@/app/SUMOCEP/store/scheduler");
const actions_1 = require("@/app/SUMOCEP/store/scheduler/actions");
const utils_1 = require("primereact/utils");
const react_redux_1 = require("react-redux");
const SchedulerTemplates = ({ onClose }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const CEPSelectedTemplate = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectCEPSelectedTemplate);
    const templates = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectCEPTemplates);
    const handleChangeTemplate = (template) => {
        dispatch(actions_1.SUMOCEPSchedulerActions.setCEPTemplate(template));
        dispatch(actions_1.SUMOCEPSchedulerActions.getSchedulerDataRequest());
        onClose();
    };
    const getTemplate = (template) => {
        return ((0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.classNames)('flex-left-center h-40px px-12px border-radius-4px text-blue-100 hover-bg-blue-4 hover-text-blue-dark cursor-pointer text-label-s-med', CEPSelectedTemplate?.id === template.id ? 'bg-blue-4 text-blue-dark' : null), onClick: () => handleChangeTemplate(template), children: (0, jsx_runtime_1.jsx)("div", { className: 'flex-center gap-12px text-gray-100', children: template.name }) }, template.id));
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column gap-10px p-4px w-320px max-h-400px overflow-y-auto', children: (0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column', children: templates.map(getTemplate) }) }));
};
exports.SchedulerTemplates = SchedulerTemplates;
